import React, {useState, useEffect, useRef} from 'react';
import { useForm, Controller} from 'react-hook-form';
import Select from "react-select";
import { NumericFormat } from 'react-number-format';
import materialService from '../../services/MaterialService';
import categoryService from '../../services/CategoryService';

const  measureType = [
    { label: 'cm', value: 'cm' },
    { label: 'm', value: 'm' },
    { label: 'mq', value: 'mq' },
    { label: 'unità', value: 'unita' }
];

export default function SlideEditMat({show,onClose,onFetchMaterials,material,idCategory}) {
    const { register, control, handleSubmit, reset,formState: { errors } } = useForm({});
    const fileInputRef = useRef(null);
    const [message, setMessage] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [resultsCat, setResultsCat] = useState([]);
    const [loading, setLoading] = useState(true);

    const closeSlide = () => {
        setErrorMsg("");
        setMessage("");
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
        onClose();
    };

    const handleActionMat= async (data) => {
        const formData = new FormData();
        const pathImgValue = data.pathImgEdit
        ? data.pathImgEdit
        : "";
        formData.append('file', pathImgValue);
        const amountFormat = data.amount && String(data.amount).includes(',')
            ? data.amount.replace(/\./g, '').replace(/,/g, '.')
            : data.amount;
        const measureFormat = data.measurement
            ? data.measurement.value
            : data.measurement;
        const payload = {
            ...data,
            amount: amountFormat,
            measurement:measureFormat,
            category:{id_category: data.category.id_category}
        };
        formData.append('material', JSON.stringify(payload));

        materialService.update(formData,reset)
            .then((res) => {
                setMessage("Materiale modificato con successo!");
                setErrorMsg("");
                onFetchMaterials(idCategory);
                if (fileInputRef.current) {
                    fileInputRef.current.value = null;
                }
            }).catch((error) => {
                console.error("Error update material: ", error);
                setMessage("");
                setErrorMsg("Errore modifica materiale. Riprova.");
            }
        );
    }

    const fetchCategories= async () => {
        try {
            const res = await categoryService.getAll();
            const resultsData = res.data || [];
            const categoryId = resultsData.find(s => s.id_category === material.id_category);
            const measure = measureType.find(s => s.value === material.measurement);
            reset({
                ...material,
                category: categoryId,
                measurement: measure,
                consumption: material.consumption ? "true" : "false",
                status: material.status ? "true" : "false"
            });
            setResultsCat(resultsData);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching Categories', error);
        }
    };

    useEffect(() => {
        const measure = measureType.find(s => s.value === material.measurement);
        reset({
            ...material,
            measurement: measure
        });
        fetchCategories();
    }, [material, reset]);

  	return (
  	    <div className={`offcanvas offcanvas-end ${show ? "show" : ""}`}>
            <div className="offcanvas-header border-bottom">
                <h5 className="offcanvas-title">Modifica Materiale: {material.name}</h5>
                <button onClick={closeSlide} className="btn-close text-reset"></button>
            </div>
            <div className="offcanvas-body mx-0 flex-grow-0 p-6 h-100">
                {errorMsg && <div className="mb-6 text-center alert alert-outline-danger">{errorMsg}</div>}
                {message && <div className="mb-6 text-center alert alert-outline-success">{message}</div>}
                <form className="add-new-user pt-0" onSubmit={handleSubmit(handleActionMat)}>
                    <div className="row">
                        <div className="col-8 mb-6">
                            <label className="form-label">Nome*</label>
                            <div className="input-group input-group-merge has-validation">
                                <span className={`input-group-text cursor-pointer ${errors.name ? "is-invalid" : ""}`}>
                                    <i className="bx bxs-component" ></i>
                                </span>
                                <Controller
                                    control={control}
                                    name="name"
                                    rules={{ required: 'Richiesto', maxLength: {value: 100,message: 'Massimo 100 caratteri' }}}
                                    render={({ field }) => (
                                        <input
                                          {...field}
                                          type="text"
                                          className={`form-control ${errors.name ? "is-invalid" : ""}`}
                                        />
                                    )}
                                />
                            </div>
                            {errors.name && <div className="invalid-input">{errors.name.message}</div>}
                        </div>
                        <div className="col-4 mb-6">
                            <label className="form-label">Codice*</label>
                            <div className="input-group input-group-merge has-validation">
                                <span className={`input-group-text cursor-pointer ${errors.code ? "is-invalid" : ""}`}>
                                    <i className="bx bx-barcode" ></i>
                                </span>
                                <Controller
                                    control={control}
                                    name="code"
                                    rules={{ required: 'Richiesto', maxLength: {value: 100,message: 'Massimo 100 caratteri' }}}
                                    render={({ field }) => (
                                        <input
                                          {...field}
                                          type="text"
                                          className={`form-control ${errors.code ? "is-invalid" : ""}`}
                                        />
                                    )}
                                />
                            </div>
                            {errors.code && <div className="invalid-input">{errors.code.message}</div>}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col mb-6">
                            <label className="form-label">Dimensioni</label>
                            <div className="input-group input-group-merge has-validation">
                                <span className={`input-group-text cursor-pointer ${errors.dimensions ? "is-invalid" : ""}`}>
                                    <i className="bx bx-ruler" ></i>
                                </span>
                                <Controller
                                    control={control}
                                    name="dimensions"
                                    rules={{maxLength: {value: 100,message: 'Massimo 100 caratteri' }}}
                                    render={({ field }) => (
                                        <input
                                          {...field}
                                          type="text"
                                          className={`form-control ${errors.dimensions ? "is-invalid" : ""}`}
                                        />
                                    )}
                                />
                            </div>
                            {errors.dimensions && <div className="invalid-input">{errors.dimensions.message}</div>}
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">Posizione</label>
                            <div className="input-group input-group-merge has-validation">
                                <span className={`input-group-text cursor-pointer ${errors.position ? "is-invalid" : ""}`}>
                                    <i className="bx bx-map" ></i>
                                </span>
                                <Controller
                                    control={control}
                                    name="position"
                                    rules={{maxLength: {value: 50,message: 'Massimo 50 caratteri' }}}
                                    render={({ field }) => (
                                        <input
                                          {...field}
                                          type="text"
                                          className={`form-control ${errors.position ? "is-invalid" : ""}`}
                                        />
                                    )}
                                />
                            </div>
                            {errors.position && <div className="invalid-input">{errors.position.message}</div>}
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">Quantità*</label>
                            <div className="input-group input-group-merge has-validation">
                                <span className={`input-group-text cursor-pointer ${errors.amount ? "is-invalid" : ""}`}>
                                    <i className="bx bx-collection" ></i>
                                </span>
                                <Controller
                                    name="amount"
                                    control={control}
                                    rules={{ required: 'Richiesto' }}
                                    render={({ field }) => (
                                        <NumericFormat
                                            {...field}
                                            className={`form-control ${errors.amount ? "is-invalid" : ""}`}
                                            thousandSeparator="."
                                            decimalSeparator=","
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            allowNegative={false}
                                        />
                                    )}
                                />
                            </div>
                            {errors.amount && <div className="invalid-input">{errors.amount.message}</div>}
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">Unità di Misura</label>
                                <Controller
                                name="measurement"
                                control={control}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            isClearable
                                            placeholder="Seleziona"
                                            classNamePrefix='filter'
                                            options={measureType}
                                        />
                                    )}
                                />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col mb-6">
                            <label className="form-label">Descrizone</label>
                            <Controller
                                control={control}
                                name="description"
                                rules={{
                                    maxLength: {
                                        value: 512,
                                        message: 'Massimo 512 caratteri'
                                    }
                                }}
                                render={({ field }) => (
                                    <textarea
                                        {...field}
                                        placeholder="Aggiungi una descrizione del materiale..."
                                        className={`form-control ${errors.description ? "is-invalid" : ""}`}
                                        rows="4"
                                    />
                                )}
                            />
                            {errors.description && <div className="invalid-input">{errors.description.message}</div>}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col mb-6">
                            <label className="form-label">{material.pathImg ? "Modifica " : "Carica "} Immagine</label>
                            <Controller
                                control={control}
                                name="pathImgEdit"
                                rules={{
                                    validate: {
                                        maxFileSize: (file) =>
                                            !file || file.size <= 150 * 1024 || "File troppo grande (max 150KB)",
                                    },
                                }}
                                render={({ field }) => (
                                    <input
                                        type="file"
                                        accept=".jpg,.jpeg,.png"
                                        className={`form-control ${errors.pathImgEdit ? "is-invalid" : ""}`}
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            field.onChange(file);
                                        }}
                                        ref={(e) => {
                                            field.ref(e);
                                            fileInputRef.current = e;
                                        }}
                                    />
                                )}
                            />
                            {errors.pathImgEdit && <div className="invalid-input">{errors.pathImgEdit.message}</div>}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col mb-6">
                            <label className="form-label">Categoria</label>
                                <Controller
                                name="category"
                                control={control}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            isClearable
                                            placeholder="Seleziona una categoria"
                                            classNamePrefix='filter'
                                            options={resultsCat}
                                            getOptionLabel={(e) => e.name}
                                            getOptionValue={(e) => e.id_category}
                                        />
                                    )}
                                />
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">Link Descrizione</label>
                            <div className="input-group input-group-merge has-validation">
                                <span className={`input-group-text cursor-pointer ${errors.externalUrl ? "is-invalid" : ""}`}>
                                    <i className="bx bx-link" ></i>
                                </span>
                                <Controller
                                    control={control}
                                    name="externalUrl"
                                    rules={{
                                        maxLength: {value: 250,message: 'Massimo 250 caratteri' },
                                        pattern: {
                                            value: /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w- ./?%&=]*)?$/,
                                            message: 'URL non valido'
                                        }
                                    }}
                                    render={({ field }) => (
                                        <input
                                          {...field}
                                          type="text"
                                          className={`form-control ${errors.externalUrl ? "is-invalid" : ""}`}
                                        />
                                    )}
                                />
                            </div>
                            {errors.externalUrl && <div className="invalid-input">{errors.externalUrl.message}</div>}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col mb-6">
                            <label className="form-label">Consumo</label>
                            <select className={`form-select ${errors.consumption ? "is-invalid" : ""}`}
                                type="text"
                                placeholder="Seleziona uno stato"
                                {...register('consumption', { required: 'Richiesto' })}
                            >
                                <option value="true">Si</option>
                                <option value="false">No</option>
                            </select>
                            {errors.consumption && <div className="invalid-input">{errors.consumption.message}</div>}
                        </div>
                        <div className="col mb-6">
                            <label className="form-label">Stato</label>
                            <select className={`form-select ${errors.status ? "is-invalid" : ""}`}
                                type="text"
                                placeholder="Seleziona uno stato"
                                {...register('status', { required: 'Richiesto' })}
                            >
                                <option value="true">Attivo</option>
                                <option value="false">Non Attivo</option>
                            </select>
                            {errors.status && <div className="invalid-input">{errors.status.message}</div>}
                        </div>
                    </div>
                    <div className="col mb-6">
                        <label className="form-label">Note</label>
                        <Controller
                            control={control}
                            name="note"
                            rules={{
                                maxLength: {
                                    value: 512,
                                    message: 'Massimo 512 caratteri'
                                }
                            }}
                            render={({ field }) => (
                                <textarea
                                    {...field}
                                    placeholder="Aggiungi una nota..."
                                    className={`form-control ${errors.note ? "is-invalid" : ""}`}
                                    rows="4"
                                />
                            )}
                        />
                        {errors.note && <div className="invalid-input">{errors.note.message}</div>}
                    </div>
                    <button type="submit" className="btn btn-primary me-3">Invia</button>
                </form>
            </div>
  	    </div>
	);
}